import { render, staticRenderFns } from "./PopupBeritaAcaraDetail.vue?vue&type=template&id=078044d3&scoped=true&"
import script from "./PopupBeritaAcaraDetail.vue?vue&type=script&lang=js&"
export * from "./PopupBeritaAcaraDetail.vue?vue&type=script&lang=js&"
import style0 from "./PopupBeritaAcaraDetail.vue?vue&type=style&index=0&id=078044d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078044d3",
  null
  
)

export default component.exports